import { useEffect, useState } from "react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";

const COMMISSIONS = [
  ["VV", "Výkonný výbor"],
  ["Sekretariát", "Sekretariát"],
  ["ŠTK", "Športovo-technická komisia"],
  ["DK", "Disciplinárna komisia"],
  ["KR", "Komisia rozhodcov"],
  ["RK", "Revízna komisia"],
  ["TMK", "Trénersko-metodická komisia"],
  ["KM", "Komisia mládeže"],
  ["OdK", "Odvolacia komisia"],
  ["VK", "Volebná komisia"],
];

export default function Structure() {
  const [members, setMembers] = useState([]);
  useEffect(() => {
    api.get("/structure").then((r) => setMembers(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="structure-page">
      <Seo title="Štruktúra ObFZ" description="Orgány a odborné komisie Oblastného futbalového zväzu Levice — Výkonný výbor, ŠTK, DK, KR, RK, TMK, KM a sekretariát." />
      <PageHeader
        eyebrow="Orgány zväzu"
        title="Štruktúra ObFZ"
        description="Výkonný výbor, sekretariát a odborné komisie ObFZ Levice pre funkčné obdobie 2025 – 2029."
        breadcrumbs={[{ label: "Štruktúra ObFZ" }]}
      />

      <section className="section-pad bg-paper">
        <div className="wrap">
          <div className="space-y-12">
            {COMMISSIONS.map(([key, label]) => {
              const list = members.filter((m) => m.commission === key);
              if (!list.length) return null;
              return (
                <div key={key} data-testid={`commission-${key}`}>
                  <h2 className="display-md mb-6 border-b-2 border-ink-900 pb-4 flex items-baseline gap-4">
                    <span>{label}</span>
                    <span className="mono text-xs font-bold text-ink-400">{String(list.length).padStart(2, "0")}</span>
                  </h2>
                  <div className="bg-white border border-ink-100 overflow-hidden">
                    <table className="data-table">
                      <thead>
                        <tr>
                          <th className="w-12">#</th>
                          <th>Meno</th>
                          <th>Funkcia</th>
                          <th className="hidden md:table-cell">Mesto / Klub</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((m, i) => (
                          <tr key={m.id}>
                            <td className="mono text-xs text-ink-400">{String(i + 1).padStart(2, "0")}</td>
                            <td className="font-semibold text-ink-900">{m.name}</td>
                            <td className="mono text-[11px] uppercase tracking-wider text-green-700">{m.role}</td>
                            <td className="hidden md:table-cell text-ink-500">{m.location || "—"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
